import React, { useCallback, useEffect, useRef, useState } from "react";
import UserInterface from "../../Components/InnerLayout/UserInterface";
import Headerbar from "../../Components/InnerLayout/Headerbar";
import { useHistory } from "react-router-dom";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import {
  addLinkedEmployee,
  changeSettingValue,
  getMerchantUserList,
  getPermissionGroupList,
  getUserManagementDetails,
  updateUserManagementDetails,
} from "../../../Redux/actions";
import { changeDateFormat, checkArray, checkNull } from "../../../helpers";
import ModelContainer from "../../Components/ModelContainer";
import ErrorContainer from "../../Components/ErrorContainer";
import LoadingBtn from "../../Components/LoadingBtn";

const addLinkEmpSchema = yup
  .object({
    linked_employee: yup.string().required(),
    user_employee_id: yup.string().when("linked_employee", {
      is: "yes",
      then: yup.string().required(),
    }),
    first_name: yup.string().when("linked_employee", {
      is: "no",
      then: yup.string().required(),
    }),
    last_name: yup.string().when("linked_employee", {
      is: "no",
      then: yup.string().required(),
    }),
    email: yup.string().when("linked_employee", {
      is: "no",
      then: yup.string().email().required(),
    }),
    group_id: yup.string().when("linked_employee", {
      is: "no",
      then: yup.string().required(),
    }),
  })
  .required();

const UserManagement = (params) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { user_details } = useSelector((state) => state.authReducer);
  const {
    user_management_details,
    user_merchant_list,
    addLinkEmpModal,
    is_add_link_emp_modal_loading,
    permission_group_list,
    is_update_management_loading,
  } = useSelector((state) => state.settingReducer);

  const [selectedMerId, setSelectedMerId] = useState("");

  const [updateUserManage, setUpdateUserManage] = useState({
    user_id: "",
    user_role_id: "",
    user_employee_id: "",
    merchant_id: "",
  });
  const setSelectedMerDetails = (userMer) => {
    console.log("userMer===>", userMer);
    setUpdateUserManage({
      user_id: `${userMer?.user_id ?? ""}`,
      user_role_id: `${userMer?.group_id ?? ""}`,
      user_employee_id: `${userMer?.employee_id ?? ""}`,
      merchant_id: `${userMer?.merchant_id ?? ""}`,
    });
    setSelectedMerId(userMer?.user?.id);
  };
  const userManageSubmitHandler = () => {
    const selectedAccObj = {
      selected: selectedAcc.map((acc) => acc.value),
    };
    const updatePayload = { ...updateUserManage, selected: selectedAccObj };
    dispatch(updateUserManagementDetails(updatePayload, selectedAccObj));
  };
  const userManageResetHandler = () => {
    if (checkArray(user_merchant_list)) {
      setSelectedMerDetails(user_merchant_list?.[0]);
    }
  };

  const [selectedAcc, setSelectedAcc] = useState(
    checkNull(user_details?.user?.merchant_id, false)
      ? [
          {
            value: `${user_details?.user?.merchant_id}`,
            label: user_details?.user?.merchant?.account_name ?? "",
          },
        ]
      : []
  );

  const [addLinkEmpInputForm, setAddLinkEmpInputForm] = useState(
    initialAddLinkEmpForm
  );

  const initialAddLinkEmpForm = {
    linked_employee: "",
    user_employee_id: "",
    first_name: "",
    last_name: "",
    email: "",
    group_id: "",
  };

  const changeAddLinkEmpInputHandler = (input, val) => {
    if (input == "linked_employee") {
      initialCompanyNameModalState({
        ...initialAddLinkEmpForm,
        linked_employee: val,
      });
    } else {
      addLinkEmpSetValue(input, val);
      setAddLinkEmpInputForm((prevState) => ({ ...prevState, [input]: val }));
    }
  };

  const {
    register: addLinkEmpReg,
    formState: { errors: addLinkEmpErrors },
    handleSubmit: addLinkEmpSubmit,
    control: addLinkEmpControl,
    setValue: addLinkEmpSetValue,
    reset: addLinkEmpReset,
  } = useForm({
    resolver: yupResolver(addLinkEmpSchema),
    defaultValues: initialAddLinkEmpForm,
    mode: "all",
    reValidateMode: "onChange",
  });

  const initialCompanyNameModalState = (newObj = initialAddLinkEmpForm) => {
    setAddLinkEmpInputForm(newObj);
    addLinkEmpReset(newObj);
  };

  const closeAddLinkEmpModal = useCallback(
    (val) => {
      dispatch(changeSettingValue("addLinkEmpModal", val));
      initialCompanyNameModalState();
    },
    [addLinkEmpModal]
  );

  const submitAddLinkEmpHandler = (data) => {
    console.log("submitAddLinkEmpHandler", data);
    dispatch(addLinkedEmployee(data));
  };

  useEffect(() => {
    if (checkArray(selectedAcc)) {
      const selectedAccObj = {
        selected: selectedAcc.map((acc) => acc.value),
      };
      dispatch(getMerchantUserList(selectedAccObj));
      dispatch(getPermissionGroupList(selectedAccObj));
    }
  }, [selectedAcc]);

  const [accArray, setAccArray] = useState([]);

  const addAccToArray = (isDisable = false) => {
    let newAccArray = [];
    Object.keys(user_management_details?.new_roles).map((role) => {
      const newAccObj = {
        value: role,
        label: user_management_details?.new_roles[role],
      };
      if (role !== "all" && isDisable) {
        newAccObj.isDisabled = true;
      }
      newAccArray.push(newAccObj);
    });
    return newAccArray;
  };

  useEffect(() => {
    if (
      user_management_details?.new_roles &&
      user_management_details?.new_roles !== null
    ) {
      setAccArray(addAccToArray());
    }
  }, [user_management_details?.new_roles]);

  useEffect(() => {
    dispatch(getUserManagementDetails());
    return () => {
      dispatch(changeSettingValue("user_management_details", null));
      dispatch(changeSettingValue("user_merchant_list", []));
      dispatch(changeSettingValue("permission_group_list", []));
    };
  }, []);

  const [userSearch, setUserSearch] = useState("");

  const userSearchHandler = (userMer) => {
    let resp = true;
    if (checkNull(userSearch, false)) {
      let searchText = userSearch.toLowerCase();
      resp = false;
      if (
        checkNull(userMer?.user?.id.toString(), false) &&
        userMer?.user?.id.toString().includes(searchText)
      ) {
        resp = true;
      } else if (
        checkNull(userMer?.user?.full_name, false) &&
        userMer?.user?.full_name.toLowerCase().includes(searchText)
      ) {
        resp = true;
      } else if (
        checkNull(userMer?.user?.email, false) &&
        userMer?.user?.email.toLowerCase().includes(searchText)
      ) {
        resp = true;
      } else if (
        checkNull(userMer?.employee?.role_title, false) &&
        userMer?.employee?.role_title.toLowerCase().includes(searchText)
      ) {
        resp = true;
      } else if (
        checkNull(userMer?.user?.updated_at, false) &&
        changeDateFormat(userMer?.user?.updated_at)
          .toLowerCase()
          .includes(searchText)
      ) {
        resp = true;
      }
    }
    return resp;
  };

  const [historySearch, setHistorySearch] = useState("");

  const historySearchHandler = (history) => {
    let resp = true;
    if (checkNull(historySearch, false)) {
      let searchText = historySearch.toLowerCase();
      resp = false;
      if (
        checkNull(history?.start, false) &&
        changeDateFormat(history?.start).toLowerCase().includes(searchText)
      ) {
        resp = true;
      } else if (
        checkNull(history?.end, false) &&
        changeDateFormat(history?.end).toLowerCase().includes(searchText)
      ) {
        resp = true;
      } else if (
        checkNull(history?.user?.full_name, false) &&
        history?.user?.full_name.toLowerCase().includes(searchText)
      ) {
        resp = true;
      } else if (
        checkNull(history?.field, false) &&
        history?.field.toLowerCase().includes(searchText)
      ) {
        resp = true;
      } else if (
        checkNull(history?.value, false) &&
        history?.value.toLowerCase().includes(searchText)
      ) {
        resp = true;
      } else if (
        checkNull(history?.value, false) &&
        checkNull(history?.replacement_value) &&
        history?.replacement_value.toLowerCase().includes(searchText)
      ) {
        resp = true;
      } else if (
        checkNull(history?.performed_user?.full_name, false) &&
        history?.performed_user?.full_name.toLowerCase().includes(searchText)
      ) {
        resp = true;
      }
    }
    return resp;
  };

  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar type={"user-management"} />

        <div className="inner-content">
          <div className="container px-0">
            <div className="row justify-content-between">
              <div className="col mx-lg-2 d-flex">
                <div class="shadowclass">
                  <div class="top-header-sec">
                    <div class="">
                      <h3 class="event-alert mt-0"> User List</h3>
                      <div class="row-fluid">
                        <div class="col-12">
                          <form
                            id="AccountSettingsIndexForm"
                            method="get"
                            accept-charset="utf-8"
                          >
                            {" "}
                            <div class="search-box">
                              <input
                                type="text"
                                placeholder="Search"
                                name="keyword"
                                id="CompanySearchTag"
                                autocomplete="off"
                                value={userSearch}
                                onChange={(e) =>
                                  setUserSearch(e?.target?.value ?? "")
                                }
                              />
                              <input type="button" />
                            </div>
                          </form>{" "}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="invoiceList">
                    <div class="row-fluid general-setting">
                      <div class="col-12">
                        <div class="table-responsive">
                          <table
                            width="100%"
                            cellspacing="0"
                            cellpadding="0"
                            class="checklist-table remove-space inventory_table filterTable_1"
                            filterby="#typedWasteKeyword"
                          >
                            <thead>
                              <tr>
                                <th width="" className="pl4">
                                  {/* <a
                                    onClick={() => closeAddLinkEmpModal(true)}
                                    class="add-new"
                                    id="add_employee_click"
                                  ></a>{" "} */}
                                  Username{" "}
                                </th>
                                <th width="">Email </th>
                                <th width="">Role Title </th>
                                <th width="">Last Date of Login </th>
                              </tr>
                            </thead>
                            <tbody>
                              {checkArray(user_merchant_list) &&
                                user_merchant_list
                                  .filter((userMer) =>
                                    userSearchHandler(userMer)
                                  )
                                  .map((userMer, merIndex) => {
                                    if (merIndex == 0 && selectedMerId == "") {
                                      setSelectedMerDetails(userMer);
                                    }
                                    return (
                                      <tr>
                                        <td class="custom_row invent-first-col">
                                          <label class="radio">
                                            {" "}
                                            {userMer?.user?.full_name ?? ""}
                                            <input
                                              type="radio"
                                              class="checkuser"
                                              data-employeeid="595"
                                              data-merchantid="272"
                                              data-roleid="5"
                                              id="get_url1"
                                              checked={
                                                userMer?.user?.id ==
                                                selectedMerId
                                              }
                                              onClick={() =>
                                                setSelectedMerDetails(userMer)
                                              }
                                              data-id="370"
                                              name="Transaction"
                                            />
                                            <span class="checkround"></span>
                                          </label>
                                        </td>
                                        <td>{userMer?.user?.email ?? ""}</td>
                                        <td>
                                          {userMer?.employee?.role_title ?? ""}
                                        </td>
                                        <td>
                                          {changeDateFormat(
                                            userMer?.user?.updated_at
                                          )}
                                        </td>
                                      </tr>
                                    );
                                  })}
                            </tbody>
                          </table>
                        </div>

                        <div class="col-12 pt-3">
                          <div class="field">
                            <button
                              class="btn green-btn-revert add-plus mx-0"
                              type="button"
                              id="add_employee_click"
                              onClick={() => closeAddLinkEmpModal(true)}
                            >
                              <i class="i-icon"> </i> Add User List
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col mx-lg-3 px-lg-0 d-flex">
                <div class="shadowclass">
                  <h4 class="event-alert ">Permission Groups</h4>
                  <div class="select-comparison FeatureAddDescriptionForm">
                    <label>Select Acc(s)</label>
                    <Select
                      className="w-100"
                      value={selectedAcc}
                      onChange={(values) => setSelectedAcc(values)}
                      options={accArray}
                      isMulti
                    />
                  </div>
                  <div class="table-responsive" id="showpermissionroles">
                    <table
                      width="100%"
                      cellspacing="0"
                      cellpadding="0"
                      class="checklist-table remove-space inventory_table"
                    >
                      <thead>
                        <tr>
                          <th width="">Account Name </th>
                          <th width="">Permission Group </th>
                        </tr>
                      </thead>
                      <tbody>
                        {checkArray(selectedAcc) &&
                          selectedAcc.map((selectedMer) => {
                            const selectedMerName = selectedMer?.label ?? "";
                            return (
                              checkArray(permission_group_list) &&
                              permission_group_list.map((group) => {
                                return (
                                  <tr>
                                    <td class="custom_row invent-first-col">
                                      <label
                                        class="radio"
                                        onClick={() => {
                                          if (
                                            selectedMer?.value !== "" &&
                                            selectedMer?.value ==
                                              updateUserManage?.merchant_id
                                          ) {
                                            setUpdateUserManage({
                                              ...updateUserManage,
                                              user_role_id: `${group?.id}`,
                                            });
                                          }
                                        }}
                                      >
                                        {selectedMerName}
                                        <input
                                          type="radio"
                                          class="check_role"
                                          name="group_role_id"
                                          checked={
                                            updateUserManage?.user_role_id ==
                                            group?.id
                                          }
                                        />
                                        <span class="checkround"></span>
                                      </label>
                                    </td>

                                    <td>{group?.name ?? ""}</td>
                                  </tr>
                                );
                              })
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div class="row mx-0 mt-3">
                <div class="btns col-4 d-flex justify-content-end py-md-4 py-2 col-12">
                  <LoadingBtn
                    is_loading={is_update_management_loading}
                    id="submit_user_mgt"
                    type="button"
                    onClick={() => userManageSubmitHandler()}
                  >
                    Save
                  </LoadingBtn>
                  <button
                    id="submit_cancel"
                    onClick={() => userManageResetHandler()}
                    class="btn cancel"
                    type="button"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>

            <div className="row justify-content-between">
              <div className="col mx-lg-2">
                <div class="shadowclass mt-3">
                  <div class="invoiceList">
                    <div class="row-fluid general-setting">
                      <div class="col-12">
                        <div class="top-header-sec">
                          <div class="">
                            <h3 class="event-alert mt-0"> History </h3>
                            <div class="row-fluid">
                              <div class="span12">
                                <form
                                  id="AccountSettingsIndexForm"
                                  method="get"
                                  accept-charset="utf-8"
                                >
                                  {" "}
                                  <div class="search-box">
                                    <input
                                      type="text"
                                      placeholder="Search"
                                      name="keyword"
                                      id="CompanySearchTag"
                                      value={historySearch}
                                      onChange={(e) =>
                                        setHistorySearch(e?.target?.value ?? "")
                                      }
                                      autocomplete="off"
                                    />
                                    <input type="button" />
                                  </div>
                                </form>{" "}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="table-responsive">
                          <table
                            width="100%"
                            cellspacing="0"
                            cellpadding="0"
                            class="checklist-table"
                          >
                            <thead>
                              <tr>
                                <th className="">Start </th>
                                <th className="">End </th>
                                <th className="col-2">Username </th>
                                <th className="">Field </th>
                                <th className=""> Permission Group </th>
                                <th className="">
                                  {" "}
                                  Replacement Permission Group{" "}
                                </th>
                                <th className=""> Performed By </th>
                              </tr>
                            </thead>
                            {/* <tbody id="invoice_list_table_body"></tbody> */}

                            <tbody>
                              {checkArray(user_management_details?.history) ? (
                                user_management_details?.history
                                  .filter((history) =>
                                    historySearchHandler(history)
                                  )
                                  .map((history) => {
                                    return (
                                      <tr>
                                        <td>
                                          {changeDateFormat(history?.start)}
                                        </td>
                                        <td>
                                          {changeDateFormat(history?.end)}
                                        </td>
                                        <td>
                                          {history?.user?.full_name ?? ""}
                                        </td>
                                        <td>{history?.field ?? ""}</td>
                                        <td>{history?.value ?? ""}</td>
                                        <td>
                                          {checkNull(history?.value, false)
                                            ? history?.replacement_value ?? ""
                                            : ""}
                                        </td>
                                        <td>
                                          {history?.performed_user?.full_name}
                                        </td>
                                      </tr>
                                    );
                                  })
                              ) : (
                                <tr>
                                  <td> No History </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ModelContainer
        title={`Select Linked Employee`}
        open={addLinkEmpModal}
        submitModal={addLinkEmpSubmit(submitAddLinkEmpHandler)}
        closeModal={closeAddLinkEmpModal}
        is_loading={is_add_link_emp_modal_loading}
      >
        <form
          class=""
          enctype="multipart/form-data"
          id="UserAddLinkedEmployeeForm"
          method="post"
          accept-charset="utf-8"
        >
          <fieldset class="">
            <ul class="form-list label-group">
              <li>
                <label class="">Linked Employee </label>
                <div class="input-wrap select-div">
                  <select
                    {...addLinkEmpReg("linked_employee")}
                    class="required"
                    id="UserLinkedEmployee"
                    value={addLinkEmpInputForm?.linked_employee}
                    onChange={(e) =>
                      changeAddLinkEmpInputHandler(
                        "linked_employee",
                        e?.target?.value
                      )
                    }
                  >
                    <option value="">Select</option>
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </select>{" "}
                  <ErrorContainer
                    errors={addLinkEmpErrors}
                    name="linked_employee"
                  />
                </div>
              </li>
              {addLinkEmpInputForm?.linked_employee == "yes" && (
                <li class="hide show_emp_yes">
                  <label class="">Employee </label>
                  <div class="input-wrap select-div">
                    <select
                      {...addLinkEmpReg("user_employee_id")}
                      class="required"
                      id="user_employee_id"
                      value={addLinkEmpInputForm?.user_employee_id}
                      onChange={(e) =>
                        changeAddLinkEmpInputHandler(
                          "user_employee_id",
                          e?.target?.value
                        )
                      }
                    >
                      <option value="">Select Employee</option>
                      {checkArray(user_management_details?.employeeslist) &&
                        user_management_details?.employeeslist.map(
                          (employee) => {
                            return (
                              <option value={employee?.id}>
                                {employee?.employee_name}
                              </option>
                            );
                          }
                        )}
                    </select>{" "}
                    <ErrorContainer
                      errors={addLinkEmpErrors}
                      name="user_employee_id"
                    />
                  </div>
                </li>
              )}
              {addLinkEmpInputForm?.linked_employee == "no" && (
                <>
                  <li class="hide show_emp_no">
                    <label class="">First Name </label>
                    <div class="input-wrap">
                      <input
                        {...addLinkEmpReg("first_name")}
                        class="required"
                        maxlength="200"
                        type="text"
                        id="UserFirstName"
                        required="required"
                        value={addLinkEmpInputForm?.first_name}
                        onChange={(e) =>
                          changeAddLinkEmpInputHandler(
                            "first_name",
                            e?.target?.value
                          )
                        }
                      />
                      <ErrorContainer
                        errors={addLinkEmpErrors}
                        name="first_name"
                      />
                    </div>
                  </li>
                  <li class="hide show_emp_no">
                    <label class="">Last Name </label>
                    <div class="input-wrap">
                      <input
                        {...addLinkEmpReg("last_name")}
                        name="data[User][last_name]"
                        class="required"
                        maxlength="200"
                        type="text"
                        id="UserLastName"
                        required="required"
                        value={addLinkEmpInputForm?.last_name}
                        onChange={(e) =>
                          changeAddLinkEmpInputHandler(
                            "last_name",
                            e?.target?.value
                          )
                        }
                      />
                      <ErrorContainer
                        errors={addLinkEmpErrors}
                        name="last_name"
                      />
                    </div>
                  </li>
                  <li class="hide show_emp_no">
                    <label class="">Email </label>
                    <div class="input-wrap">
                      <input
                        {...addLinkEmpReg("email")}
                        name="data[User][email]"
                        class="required"
                        type="email"
                        id="UserEmail"
                        required="required"
                        value={addLinkEmpInputForm?.email}
                        onChange={(e) =>
                          changeAddLinkEmpInputHandler(
                            "email",
                            e?.target?.value
                          )
                        }
                      />
                      <ErrorContainer errors={addLinkEmpErrors} name="email" />
                    </div>
                  </li>
                  <li class="hide show_emp_no">
                    <label class="">Permission Group </label>
                    <div class="input-wrap select-div">
                      <select
                        {...addLinkEmpReg("group_id")}
                        class="required"
                        id="UserGroupId"
                        required="required"
                        value={addLinkEmpInputForm?.group_id}
                        onChange={(e) =>
                          changeAddLinkEmpInputHandler(
                            "group_id",
                            e?.target?.value
                          )
                        }
                      >
                        <option value="">Select</option>
                        {checkArray(user_management_details?.groups) &&
                          user_management_details?.groups.map((group) => {
                            return (
                              <option value={group?.id}>{group?.name}</option>
                            );
                          })}
                      </select>{" "}
                      <ErrorContainer
                        errors={addLinkEmpErrors}
                        name="group_id"
                      />
                    </div>
                  </li>
                </>
              )}
            </ul>
          </fieldset>
        </form>
      </ModelContainer>
    </UserInterface>
  );
};
export default UserManagement;
